module.exports = __webpack_public_path__ + "img/3robo.ab7ff6e7.svg";